import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  lookupToolbar: {
    position: 'absolute',
    left: 32,
    top: 140,
    zIndex: 1000,
  },
});
